var $ = require('jquery');
var premiumDialog = require('./premiumDialog');

diy.angular.registerFactory('diyfmsource123rf', [
    '$q',
    '$injector',
    '$http',
    '$sce',
    'diyl10n',
    'diyfeatures',
    'diyfmmessages',
    'diyinfo',
    'diywebsiteid',
    'diyfmfileitemmodel',
    'diyglobalevents',
    'diyfmconfig',
    'diyfmconst123rf',
    'diyfmtracking',
function(
    $q,
    $injector,
    $http,
    $sce,
    diyl10n,
    diyfeatures,
    diyfmmessages,
    diyinfo,
    diywebsiteid,
    diyfmfileitemmodel,
    diyglobalevents,
    diyfmconfig,
    diyfmconst123rf,
    diyfmtracking
) {
    var
        source = {},
        itemsProvider = {},
        sourceServiceUrl = null,
        MAX_TOTAL_ITEMS_NO_SEARCH = 1000,
        MAX_TOTAL_ITEMS = 10000
    ;

    var getName = function() {
        return '123rf';
    };

    var getSectionModel = function() {
        return $injector.get('diyfmsection123rf');
    };

    var isAvailable = function() {
        return diyfeatures('123rf');
    };

    var getLanguage = function () {
        return diyinfo.getLanguage().substr(0, 2);
    };

    itemsProvider.queryRange = function(params, offset, limit) {
        params = params || {};
        var defer = $q.defer(), textSearch;

        if (isAvailable()) {
            var pathParams = '';

            // extract filters //
            textSearch = params.hasOwnProperty('search') ? params.search : '';

            // compose path params //
            pathParams += '?language=' + encodeURIComponent(getLanguage());
            pathParams += '&q=' + encodeURIComponent(textSearch);

            // find the smallest limit for fixed pagination
            var bLimit = limit;
            while (offset % bLimit + limit > bLimit) {
                bLimit++;
            }
            pathParams += '&perpage=' + bLimit;
            var pageNumber = Math.floor(offset / bLimit);
            pathParams += '&page=' + (pageNumber + 1);
            var bOffset = bLimit * pageNumber ;

            var serviceUrl = '/app/cms/123rf/list'
            $http.get(serviceUrl + pathParams).then(function (response) {
                try {
                    var data = response.data.data, images = data.images, length = images.length, convertedImages = [];

                    var start = offset - bOffset, end = Math.min(length, start + limit);

                    for (var i = start; i < end; i++) {
                        convertedImages.push({
                            id: images[i].id,
                            thumb: images[i].thumb,
                            file: null,
                            preview: images[i].preview
                        });
                    }

                    var maxTotal = textSearch === '' ? MAX_TOTAL_ITEMS_NO_SEARCH : MAX_TOTAL_ITEMS;

                    defer.resolve({
                        items: convertedImages,
                        totalCount: Math.min(data.paging.total_items, maxTotal - maxTotal % bLimit)
                    });
                } catch (err) {
                    diyfmmessages.handleGenericError();
                    defer.reject();
                }
            }, function (response) {
                diyfmmessages.handleGenericError();
                defer.reject();
            });

        } else {
            // set empty items
            defer.resolve({items: [], totalCount: 0});
        }

        return defer.promise;
    };

    var getItemsProvider = function() {
        return itemsProvider;
    };

    var _123rfSelectedImages = 0;
    var maxNumberOfImages, purchasedImages, availableImages;
    var premiumPayload;

    var toolbarItems = [];
    if (isAvailable()) {
        premiumPayload = diyfeatures.getPayload('premiumImages');
        maxNumberOfImages = premiumPayload.maxImages;
        purchasedImages = premiumPayload.purchasedImages;
        if (purchasedImages === false) {
            // there was an error retrieving purchasedImages so defensively assume limit is reached
            // and populate make a dummy array of maxNumberOfImages length
            purchasedImages = maxNumberOfImages;
        }
        availableImages = diyfeatures.getPayload('123rf').availableImages;
        toolbarItems = [
            function () {
                var obj = {
                    used : '<strong>' + purchasedImages + '</strong>',
                    total : '<strong>' + maxNumberOfImages + '</strong>'
                };
                return '<div>' + diyl10n('filemanager.bigstockSection.remainingMessage').format(obj) + '</div>';
            },
            ' ', // spacer
            'search'
        ];
    }

    var getToolbarItems = function(subsection) {
        return toolbarItems;
    };

    var beforeInsert = function(batch) {
        var defer = $q.defer();
        var _123rfRes = batch[0].getResource();
        $.ajax({
            type: 'POST',
            url: '/app/cms/123rf/storage',
            data: {
                id: _123rfRes.id
            },
            success: function(response, status, jqXHR) {
                if (response.success) {
                    // add image id to the list of purchased images, in case it isn't there yet
                    if (availableImages.indexOf(_123rfRes.id) === -1) {
                        availableImages.push(_123rfRes.id);
                        premiumPayload.purchasedImages++;
                    }

                    $http.get('/rest/websites/' + diywebsiteid + '/storage-files/' + response.data.storageFileId).then(function(response){
                        var fileItem = new diyfmfileitemmodel(response.data);

                        diyglobalevents.trigger('diy-editor-filemanager-addedFiles');
                        defer.resolve([fileItem]);
                    }, function() {
                        diyfmmessages.handleGenericError();
                        defer.reject();
                    });
                } else {
                    diyfmmessages.handleGenericError();
                    defer.reject();
                }
            },
            error: function(jqXHR, status, errorThrown) {
                diyfmmessages.handleGenericError();
                defer.reject();
            }
        });

        return defer.promise;
    };

    var limitDialogOpen = false;

    var canAddToInsert = function (item) {
        if (availableImages.indexOf(item.getId()) !== -1) {
            return true;
        }

        if (diyfmconfig.getMaxSelection() === 1) {
            _123rfSelectedImages = 0;
        }

        if (_123rfSelectedImages + purchasedImages >= maxNumberOfImages) {
            // show dialog
            var btnAction = function() {
                window.open('http://www.123rf.com/photo_' + item.getId() + '.html');
                premiumDialog.closeDialog();
                limitDialogOpen = false;
                diyfmtracking.track('jumpTo123RF');
            };
            var btnCancelAction = function() {
                premiumDialog.closeDialog();
                limitDialogOpen = false;
                diyfmtracking.track('cancelJumpTo123RF');
            };
            // preload image
            var img = new Image();

            img.src = item.getPreview();
            var showDialog = function () {
                if (limitDialogOpen) return;
                limitDialogOpen = true;
                premiumDialog.showLimitDialog(btnAction, btnCancelAction, maxNumberOfImages, item.getPreview());
                diyfmtracking.track('123RFLimit');
            }
            if (img.complete) {
                showDialog();
            } else {
                img.onload = showDialog;
                img.onerror = showDialog;
            }
            return false;
        } else {
            _123rfSelectedImages++;
            return true;
        }
    }

    var itemRemovedFromInsert = function (item) {
        if (availableImages.indexOf(item.getId()) !== -1) {
            return true;
        }
        _123rfSelectedImages--;
    }

    var beforeSubsectionShow = function (subsection) {
        if (subsection.getId() === diyfmconst123rf  && window.localStorage) {
            var _123rfMessageUnderstood = '_123rfMessageUnderstood' + diywebsiteid;
            var localData = JSON.parse(window.localStorage.getItem(_123rfMessageUnderstood));
            if (!localData) {
                // show dialog
                var btnAction = function() {
                    window.localStorage.setItem(_123rfMessageUnderstood, JSON.stringify(true));
                    premiumDialog.closeDialog();
                };
                premiumDialog.showInitialDialog(btnAction, maxNumberOfImages);
            }
        }
    };

    return angular.extend(source, {
        getName: getName,
        getSectionModel: getSectionModel,
        getItemsProvider: getItemsProvider,
        isAvailable: isAvailable,
        getToolbarItems: getToolbarItems,
        beforeInsert: beforeInsert,
        canAddToInsert: canAddToInsert,
        itemRemovedFromInsert: itemRemovedFromInsert,
        beforeSubsectionShow: beforeSubsectionShow
    });
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/sources/diyfmsource123rf.js
 ** module id = 953
 ** module chunks = 0
 **/